import { channelFromSearch, withChannel } from '@features/tree/channel'
import { useI18n } from '@i18n/I18nProvider'
import { ButtonLink } from '@ui/Button'
import { Screen } from '@ui/Screen'
import { useSearch } from 'wouter'
import { ReportForm } from './ReportForm'

// Pantalla de aviso (`/a/:código/aviso`): el formulario entero de una vez. Desde el mapa y desde la
// ficha del árbol el aviso se hace allí mismo (ReportForm paso a paso); esta ruta se conserva para
// los enlaces que ya existan.
export const ReportPage = ({ code }: { code: string }) => {
	const { t } = useI18n()
	const channel = channelFromSearch(useSearch())
	const treeHref = withChannel(`/a/${code.toUpperCase()}`, channel)
	return (
		<Screen title={t('report.title', { code: code.toUpperCase() })} backHref={treeHref}>
			<ReportForm
				code={code}
				channel={channel}
				doneAction={
					<ButtonLink href={treeHref} fullWidth>
						{t('report.backToTree')}
					</ButtonLink>
				}
			/>
		</Screen>
	)
}
